import { Link } from 'react-router';

export default function ValueProposition() {
  return (
    <div className="flex flex-col justify-center h-full">
      {/* Header */}
      <div className="mb-10 flex items-center justify-between">
        <span className="text-2xl font-bold text-primary">Gamgee</span>
        <Link to="/blog" className="text-sm font-medium hover:text-primary transition-colors">
          Blog
        </Link>
      </div>

      {/* Headline */}
      <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-4">
        Reduce RTO. Convert more. Retain better.
      </h1>

      {/* Subhead */}
      <p className="text-lg opacity-70 mb-10">
        We turn your data into actions that scale revenues and improve margins.
      </p>

      {/* Benefits */}
      <ul className="list mb-10">
        <li className="list-row items-center">
          <div className="text-4xl font-thin opacity-30 tabular-nums">01</div>
          <div className="list-col-grow">
            <div className="font-medium">Reduce RTO & cancellations</div>
            <div className="text-sm opacity-60">Spot high-risk orders before they ship. Stop losing money on failed deliveries.</div>
          </div>
        </li>

        <li className="list-row items-center">
          <div className="text-4xl font-thin opacity-30 tabular-nums">02</div>
          <div className="list-col-grow">
            <div className="font-medium">Convert more visitors</div>
            <div className="text-sm opacity-60">Find where customers drop off and what's blocking them from buying.</div>
          </div>
        </li>

        <li className="list-row items-center">
          <div className="text-4xl font-thin opacity-30 tabular-nums">03</div>
          <div className="list-col-grow">
            <div className="font-medium">Improve retention</div>
            <div className="text-sm opacity-60">Understand what drives repeat orders and why customers don't come back.</div>
          </div>
        </li>
      </ul>

      {/* Trust Badges */}
      <div className="flex items-center gap-3 text-sm opacity-60">
        <span>Quick setup</span>
        <span className="opacity-40">·</span>
        <span>Works with Shopify, Meta, Delhivery</span>
      </div>
    </div>
  );
}
